import axios from "axios";
import { serviceBaseURL,gisserviceBaseURL} from "./EndPoints";
export async function getData(endPoint) {
  try {
    let url = '/'+process.env.REACT_APP_CORE_CONTEXT_PATH_NAME+endPoint;
    const response = await axios.get(url,{
      withCredentials: true ,
      headers: {
          Authorization: 'Bearer '+localStorage.getItem("auth_token"),
      }
     });
    // Accept any 2xx — some endpoints (e.g. /user/validateUserName) answer 201 Created
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
    }
  } catch (error) {
    return [];
  }
}
export async function putData(endPoint, data = null) {
  try {
    let url = '/' + process.env.REACT_APP_CORE_CONTEXT_PATH_NAME + endPoint;
    
    const config = {
      withCredentials: true,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        'Content-Type': 'application/json'
      }
    };

    const response = await axios.put(url, data, config);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  } catch (error) {
    console.error('PUT request failed:', error);
    return null;
  }
}

export async function getDataFrGIS(endPoint, body,header) {
  try {
    const response = await axios.get(gisserviceBaseURL + endPoint,{headers:header})  ;
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } 
    else {
    }
    return response.data;
  } 
  catch (error) {
    return [];
  }
}


export async function postDataWithBodyFrGIS(endPoint, body,header) {
  try {
    const response = await axios.post(gisserviceBaseURL + endPoint, body,{headers:header})  ;
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } 
    else {
    }
    return response.data;
  } 
  catch (error) {
    return [];
  }
}
export async function postDataWithBody(endPoint, body,header) {
  header["Authorization"] = 'Bearer '+localStorage.getItem("auth_token");
  try {

    let url = '/'+process.env.REACT_APP_CORE_CONTEXT_PATH_NAME+endPoint;
    const response = await axios.post(url, body,{headers:header})  ;
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } 
    else {
    }
    return response.data;
  } 
  catch (error) {
    return [];
  }
}

export async function postDataWithFiles(endPoint, formData) {
  try {
    let url = '/' + process.env.REACT_APP_CORE_CONTEXT_PATH_NAME + endPoint;
    const response = await axios.post(url, formData, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        // Note: Don't set Content-Type here - axios will set it automatically with boundary for FormData
      }
    });
    
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
    }
    return response.data;
  } catch (error) {
    return [];
  }
}

export async function putDataWithBody(endPoint, body,header) {
  try {
    header["Authorization"] = 'Bearer '+localStorage.getItem("auth_token");
    let url = '/'+process.env.REACT_APP_CORE_CONTEXT_PATH_NAME+endPoint;
    const response = await axios.put(url, body,{headers:header})  ;
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } 
    else {
    }
    return response.data;
  } 
  catch (error) {
    return [];
  }
}
export async function deleteData(endPoint, id) {
  try {
    const response = await axios.delete(endPoint, {
      withCredentials: true ,
      headers: {
          Authorization: 'Bearer '+localStorage.getItem("auth_token"),
      }
     });
    if (response.status === 200) {
      return response.data;
    } else {
    }
  } catch (error) {
    return [];
  }
}

export async function deleteDataById(baseURL, id) {
  try {
    const endPoint = `${baseURL}/${id}`;
    let url = '/'+process.env.REACT_APP_CORE_CONTEXT_PATH_NAME+endPoint;
    const response = await axios.delete(url, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
      },
    });

    if ( response.status === 200 || response.status === 201 || response.status === 204) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

export async function editData(endPoint, id) {
  try {
    const response = await axios.put(endPoint);
    if (response.status === 200) {
      return response.data;
    } else {
    }
  } catch (error) {
    return [];
  }
}

export async function fileUploadService(endPoint, formData) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    const response = await axios.post(
      serviceBaseURL + endPoint,
      formData,
      config
    );
    if (response.status === 200) {
      return response.data;
    } else {
    }
  } catch (error) {
    return [];
  }
}
export async function getWFSServiceData(endPoint, cqlquery) {
  try {
    const gisserverurl = process.env.REACT_APP_GEO_SERVER;
    let wfsurl =gisserverurl+endPoint+"&CQL_FILTER=" + cqlquery;
    const response = await axios.get(wfsurl,{headers:{}})  ;
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } 
    else {
    }
    return response.data;
  } 
  catch (error) {
    return [];
  }
}

export async function getWFSLayer(endPoint) {
  try {
    const response = await axios.get(endPoint,{headers:{}})  ;
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } 
    else {
    }
    return response.data;
  } 
  catch (error) {
    return [];
  }
}

export const getImageByFacility = async (facilityId,typeid,opendate) => {
  try {
    const headers = {
      Authorization: 'Bearer ' + localStorage.getItem("auth_token")
    };

    const response = await axios.get(
      `/dms-service/facility_report/getImageByFacility?facilityId=${facilityId}&facilityTypeId=${typeid}&openDate=${opendate}`,
      { headers }
    );
    return response.data;
  } catch (error) {
  }
};

export async function getDataById(baseURL, id) {
  try {
    const endPoint = `${baseURL}/${id}`;
    const url = `/${process.env.REACT_APP_CORE_CONTEXT_PATH_NAME}${endPoint}`;
    const response = await axios.get(url, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

